import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { simpleDeepClone } from '@phx-erp/shared';
import { DisableFormDirective } from '../../../../../@core/directives/disable-form.directive';
import { AddressPostalLink, PostalAddress } from '../../../../../generated/generated-types';
import { AddressPostalLinkService } from '../../../../crm/services/address-postal-link.service';
import { AddressService } from '../../../../crm/services/address.service';
import { PostalAddressService } from '../../../../crm/services/postal-address.service';
import { WidgetEditGenericDocumentComponent } from '../../widget-edit-generic-document/widget-edit-generic-document.component';
import { DocumentDeliveryPostalAddressDropdownComponent } from '../document-delivery-postal-address-dropdown/document-delivery-postal-address-dropdown.component';
import { documentDeliveryPostalAddressFallbackFields } from './fallback-fields';

@Component({
  selector: 'app-formly-document-delivery-postal-address-widget',
  templateUrl: './formly-document-delivery-postal-address-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DisableFormDirective,
    FormlyModule,
    ReactiveFormsModule,
    FormsModule,
    TranslatePipe,
    DocumentDeliveryPostalAddressDropdownComponent,
  ]
})
export class FormlyDocumentDeliveryPostalAddressWidgetComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {


  subForm = new FormGroup({});
  fallbackFields: any[];

  newModel: PostalAddress = {} as any;

  dropdownActive: boolean = false;

  constructor(
    private addressService: AddressService,
    private postalAddressService: PostalAddressService,
    private addressPostalLinkService: AddressPostalLinkService,
    private cdRef: ChangeDetectorRef) {
    super();
  }



  async ngAfterViewInit(): Promise<void> {
    this.field.props.icon = "fa-solid fa-truck";

    this.fallbackFields = documentDeliveryPostalAddressFallbackFields();
    //TODO load fields from server, we can extends our base class to fieldtype

    //this will be triggered by the fallback form and update the formControl
    this.subForm.valueChanges.subscribe(x => {

      let errors: ValidationErrors = Object.keys(this.subForm.controls).reduce((acc, key) => {
        const control = this.subForm.controls[key];
        if (control.errors) {
          const errorKey = Object.keys(control.errors)[0];
          acc[errorKey] = control.errors[errorKey];
        }
        return acc;
      }, {});

      //pass change up to parent
      this.formControl.setValue(this.newModel);
      if (Object.keys(errors).length > 0)
        this.formControl.setErrors(errors);

    });

    //this will be triggered by the parent formControl and update the fallback form
    this.formControl.valueChanges.subscribe(x => {
      // console.log('form1.valueChanges', x);
      this.newModel = x;
      this.cdRef.detectChanges();
    });

    if (this.formControl.value)
      this.newModel = simpleDeepClone(this.formControl.value);

    // Register inner fallback fields so document-level configs can target nested postal keys.
    (this.options.formState?.detailComponent as WidgetEditGenericDocumentComponent | undefined)?.registerPostalInnerFieldConfigApplier(
      'deliveryPostalAddress',
      () => this.fallbackFields,
    );

    this.cdRef.detectChanges();
  }

  async selectedPostalAddressChanged(newAddressPostalLink: AddressPostalLink | AddressPostalLink[]) {

    this.dropdownActive = false;

    if (Array.isArray(newAddressPostalLink)) {
      newAddressPostalLink = newAddressPostalLink[newAddressPostalLink.length - 1];
    }

    // will not return null if empty, but we want that
    // if (!newAddressPostalLink)
    //   return; //clear?

    if (this.options.formState?.detailComponent) {
      let widget = this.options.formState.detailComponent as WidgetEditGenericDocumentComponent;
      await widget.deliveryPostalAddressChanged(newAddressPostalLink);
    }
    this.cdRef.detectChanges();
  }
}
